module.exports = __webpack_public_path__ + "img/12.3d71e606.svg";